import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import slugify from '../../../assets/scripts/utilities/slugify.js'

const COLOR_MAP = {
  chapters: ['green', 'cyan', 'blue', 'purple', 'magenta'],
  themes: ['orange'],
}
const LANGUAGE_MAP = { en: 'en', fi: 'nl' }
const DATA_SOURCES = { themes: 'KdDGn', chapters: 'yjkVk', index: 'PdkQD' }

/* Data shape:
{
  themes: { title: '', items: [
    { title: '', color: '', objects: [
      { title: '', linkHref: '', imageSrc: '' }
    ] }
  ] },
  chapters: { title: '', items: [
    { title: '', color: '', objects: [
      { title: '', linkHref: '', imageSrc: '' }
    ] }
  ] },
  index: {
    intro: { title: '', text: '', text2: '' },
    about: { title: '', text: '', text2: '' },
  },
}
*/

const addMicrioVersionToUrl = url => url.replace(/(.*)(micr\.io)(.*)/, '$1$2$3?v=4.3')
const sanitizeText = (str = '') => str.replace(/(\\u2028|\\u2029|\s\s+|\n)/g, ' ').trim() || null
const sanitizeTextIncludeNewlines = (str = '') =>
  str
    .replace(/(\\u2028|\\u2029)/g, ' ')
    .replace(/(\n\n+)/g, '\n\n&nbsp;\n\n') // Quick hack to make snarkdown respect multiple newlines
    .trim() || null
const dataUrl = (id, lang) => `https://b.micr.io/${id}/data.${LANGUAGE_MAP[lang] || 'en'}.json`

class MicrioDataComponent extends Component {
  init() {
    this.language = document.documentElement.lang || 'en'
    this.dataSources = { ...DATA_SOURCES }
    this.data = {}

    window.addEventListener('init-after-load', this.initAfterLoad())
  }

  async initAfterLoad() {
    for (const [key, value] of Object.entries(this.dataSources)) {
      this.dataSources[key] = await fetch(dataUrl(value, this.language)).then(response => response.ok && response.json())
    }

    this.data.themes = this.loadMenuData('themes')
    this.data.chapters = this.loadMenuData('chapters')
    this.data.index = this.loadMarkerData(['intro', 'about'])

    console.log(this.data)

    window.dispatchEvent(new CustomEvent('micrio-data', { detail: this.data }))
  }

  loadMenuData(key = '') {
    const results = { title: '', items: [] }

    if (!key || !this.dataSources[key]) {
      return results
    }

    console.log('!', key, this.dataSources[key])

    results.title = sanitizeText(this.dataSources[key].descriptionMarkdown || '')

    for (const item of this.dataSources[key].pages) {
      const index = this.dataSources[key].pages.indexOf(item)
      const { title, children } = item
      const result = {
        title: sanitizeText(title),
        href: addMicrioVersionToUrl(children.filter(child => child.link && !child.image)[0]?.link || ''),
        color: COLOR_MAP[key][index % COLOR_MAP[key].length],
        objects: children
          .filter(child => child.link && child.image)
          .map(child => ({
            title: sanitizeText(child.title),
            linkHref: addMicrioVersionToUrl(child.link),
            imageSrc: child.image,
          })),
      }
      result.slug = slugify(`${key}-${result.title}`)

      results.items.push(result)
    }

    return results
  }

  loadMarkerData(keys = []) {
    const results = {}

    if (!keys.length) {
      return results
    }

    for (const key of keys) {
      const items = this.dataSources.index.markers?.filter(({ class: classNames }) => classNames.indexOf(key) !== -1) || []

      for (const { title, markdown: text, markdownSecondary: text2 } of items) {
        results[key] = {
          title: sanitizeText(title),
          text: sanitizeTextIncludeNewlines(text),
          text2: sanitizeTextIncludeNewlines(text2),
        }
      }
    }

    return results
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'micrio-data', MicrioDataComponent))
